export default __webpack_public_path__ + "dbd56a9707aa483106b322e1f84cdf03.svg";